export enum EmailEventDiscriminator {
  Split = 'com.apsis1.events.email.split-test',
  TransactionalEmailSent = 'com.apsis1.events.transactional-email.sent',
  TransactionalEmailDelivered = 'com.apsis1.events.transactional-email.delivered',
  TransactionalEmailOpen = 'com.apsis1.events.transactional-email.open',
  TransactionalEmailClick = 'com.apsis1.events.transactional-email.click',
  TransactionalEmailBounce = 'com.apsis1.events.transactional-email.bounce',
  TransactionalEmailAbuse = 'com.apsis1.events.transactional-email.abuse',
}

export const transactionalEmailEventsList = [
  EmailEventDiscriminator.TransactionalEmailSent,
  EmailEventDiscriminator.TransactionalEmailDelivered,
  EmailEventDiscriminator.TransactionalEmailOpen,
  EmailEventDiscriminator.TransactionalEmailClick,
  EmailEventDiscriminator.TransactionalEmailBounce,
  EmailEventDiscriminator.TransactionalEmailAbuse,
];
